/* Match the existing WhatsApp app's open shadow component to the store palette. */
(() => {
  const styleContact = () => {
    document.querySelectorAll('gty-whatsapp-chat-button').forEach(host => {
      const root = host.shadowRoot;
      if (!root || root.querySelector('[data-hamilton-palette]')) return;
      const style = document.createElement('style');
      style.dataset.hamiltonPalette = '';
      style.textContent = '.gty-wacb-button{background-color:#2B2B2B!important;border:1px solid #B3B3B3!important}.gty-wacb-button:focus-visible{outline:2px solid #2B2B2B;outline-offset:3px}.gty-wacb-button:hover{box-shadow:0 0 0 2px #D4D4D4}';
      root.append(style);
    });
  };
  const observer = new MutationObserver(styleContact);
  observer.observe(document.body, {childList:true, subtree:true});
  customElements.whenDefined('gty-whatsapp-chat-button').then(styleContact);
  styleContact();
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
})();
